<div class="flx-modal" role="dialog" aria-modal="true">
    <div class="flx-modal__header">
        <div class="with-desc">
            <h2 id="label_SiteBlockContractTitle">{{translate?.general.buttons.new.singular}} {{translate?.contracts.label.singular}}</h2>
        </div>
        <button class="icon-btn" aria-label="Close" id="btn_SiteBlockContractClose" [pTooltip]="translate?.general.buttons.close.singular"
            (click)="modalRef.hide()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>

    <div class="flx-modal__body mp-body">
        <form [formGroup]="contractForm">
            <div class="status-field">
                <label class="field-label mandatory" id="label_SiteBlockContractNameLabel">{{translate?.contracts.label.singular}}</label>
                <div class="field-row field-row--single">
                    <div>
                        <input pInputText formControlName="contractName" id="input_SiteBlockContractNameField"
                            [placeholder]="translate?.site.messages.enterAName + ' ' + translate?.contracts.label.singular" />
                        <div class="p-error text-10 mt-1" id="label_SiteBlockContractNameError" *ngIf="
                                (contractForm.controls['contractName'].touched || contractForm.controls['contractName'].dirty) &&
                                contractForm.controls['contractName'].invalid
                            ">
                            <span
                                id="label_SiteBlockContractNameRequiredError"
                                *ngIf="contractForm.controls['contractName'].errors?.required">{{translate?.general.validationFE.requiredField}}</span>
                            <span id="label_SiteBlockContractNamePatternError" *ngIf="contractForm.controls['contractName'].errors?.pattern">
                                {{translate?.general.validationFE.invalid}} {{ translate?.contracts.label.singular}} {{translate?.customer.fields.name.singular}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="status-field">
                <label class="field-label mandatory" id="label_SiteBlockContractCusLabel">{{translate?.customer.label.singular}}</label>
                <div class="field-row field-row--single">
                    <div>
                        <div class="p-inputgroup search">
                            <span class="p-input-icon-right w-100">
                                <p-autoComplete (onSelect)="gotSelectedCustomer($event)" id="picklist_SiteBlockContractCusField"
                                    field="name" [suggestions]="customers"
                                    (completeMethod)="getCustomerIdsFirstWay($event)"
                                    [placeholder]="translate?.general.commonComponent.messages.selectA + ' ' + translate?.customer.label.singular"
                                    name="customer" formControlName="customer" styleClass="w-100"
                                    [ngClass]="{'ng-invalid ng-dirty': contractForm.controls['customer'].touched && contractForm.controls['customer'].invalid}">
                                </p-autoComplete>
                                <i *ngIf="selectedCustomer" (click)="clearValue()" id="btn_SiteBlockContractCusClear"
                                    class="p-autocomplete-clear-icon pi pi-times"></i>
                            </span>
                            <button type="button" pButton icon="fa-regular fa-magnifying-glass"
                                [pTooltip]="translate?.customer.tooltips.customerLookup.singular" tooltipPosition="left"
                                id="btn_SiteBlockContractCusSearch" (click)="showTable()"></button>
                        </div>
                        <div class="p-error text-10" id="label_SiteBlockContractCusError" *ngIf="
                            (contractForm.controls['customer'].touched || contractForm.controls['customer'].dirty) &&
                            contractForm.controls['customer'].invalid
                        ">
                            <span
                                id="label_SiteBlockContractCusRequiredError"
                                *ngIf="contractForm.controls['customer'].errors?.required">{{translate?.general.validationFE.requiredField}}</span>
                        </div>
                    </div>
                    <footer *ngIf="displayTable" class="custella-form-container-footer hidePopup">
                        <p-dialog [header]="translate?.customer.sections.sec5.singular" id="title_CustDet"
                            [(visible)]="displayTable" showEffect="fade" [style]="{ width: '70vw' }" [modal]="true"
                            [draggable]="false">
                            <app-custella-customers (selectCustomerEvent)="gotSelectedCustomer($event)"
                                (closeCustomerEvent)="closeCustomerView()"></app-custella-customers>
                        </p-dialog>
                    </footer>
                </div>
            </div>

            <div class="status-field">
                <div class="field-row--auto_range mp-row">
                    <div class="status-field">
                        <span class="field-label" id="label_SiteBlockContractStartDateLabel">{{translate?.site.fields.startDate.singular}}</span>
                        <p-calendar formControlName="startDate" id="picklist_SiteBlockContractStartDateField" dateFormat="d/m/yy"
                            (onSelect)="onStartDateSelect($event)" [showIcon]="true" appendTo="body"
                            placeholder="dd/mm/yy" styleClass="cal-btn" [maxDate]="maxStartDate"></p-calendar>
                        <div class="p-error text-10" id="label_SiteBlockContractStartDateError" *ngIf="
                                (contractForm.controls['startDate'].touched || contractForm.controls['startDate'].dirty) &&
                                contractForm.controls['startDate'].invalid
                            ">
                            <span
                                id="label_SiteBlockContractStartDateRequiredError"
                                *ngIf="contractForm.controls['startDate'].errors?.required">{{translate?.general.validationFE.requiredField}}</span>
                        </div>
                    </div>
                    <span class="divider"><i class="fa-solid fa-minus"></i></span>
                    <div class="status-field">
                        <span class="field-label" id="label_SiteBlockContractEndDateLabel">{{translate?.site.fields.endDate.singular}}</span>
                        <p-calendar formControlName="endDate" id="picklist_SiteBlockContractEndDateField" dateFormat="d/m/yy" [placeholder]="translate?.site.messages.todaysDate"
                            [showIcon]="true" appendTo="body" [minDate]="minEndDate" styleClass="cal-btn" (onSelect)="onEndDateSelect($event)"></p-calendar>
                        <div class="p-error text-10" id="label_SiteBlockContractEndDateError" *ngIf="
                                (contractForm.controls['endDate'].touched || contractForm.controls['endDate'].dirty) &&
                                contractForm.controls['endDate'].invalid
                            ">
                            <span
                                id="label_SiteBlockContractEndDateRequiredError"
                                *ngIf="contractForm.controls['endDate'].errors?.required">{{translate?.general.validationFE.requiredField}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>

    <div class="flx-modal__footer">
        <button class="custella-btn-white" id="btn_SiteBlockContractCancel"
            (click)="modalRef.hide()">{{translate?.general.buttons.cancel.singular}}</button>
        <p-button type="button" (onClick)="onContractCreate()" id="btn_SiteBlockContractSave" [label]="translate?.general.buttons.save.singular"
            styleClass="h-32"></p-button>
    </div>
</div>